import VueBaseController from '../../vue_base'

// eslint-disable-next-line import/prefer-default-export
export class NewController extends VueBaseController {
  static get COMPONENT() {
    return () => import('@/vue/pages/users/ai_content/bulk_jobs/new.vue')
  }
}
